import React, {FC} from 'react';
import './style.scss';
import {useHistory} from "react-router-dom";
import {pathSuite} from "../../../constants";
import {ICompilation} from "../../../constants/types";

interface ICompilationsGroupCard {
    title: string,
    id: number,
    idCompilations: number,
    compilations: Array<ICompilation>,
    setIndexCompilations: any,
    fetchMixCompilation: any,
    setCurrentCompilations: any
}


const CompilationsGroupCard: FC<ICompilationsGroupCard> = ({
                                                               title,
                                                               compilations,
                                                               id,
                                                               idCompilations,
                                                               setIndexCompilations,
                                                               fetchMixCompilation,
                                                               setCurrentCompilations
                                                           }) => {

    const history = useHistory();


    const showAllCompilations = (id: number, idCompilations: number) => {
        history.push(`/main/list-compilation/${idCompilations}`);
        setCurrentCompilations(id, +idCompilations);
        setIndexCompilations(idCompilations);
    };

    const getDetailedInfo = (id: number) => {
        fetchMixCompilation(id);
        setCurrentCompilations(id);
        history.push(`/main/compilation/${id}`)
    };

    return (
        <div className="collections__card-wrapper">
            <div className="collections__card-header">
                <div className="collections__card-title">
                    {title}
                </div>
                <div className="collections__card-all"
                     onClick={() => showAllCompilations(compilations[0].id, id)}
                >
                    См. все
                </div>
            </div>
            <div
                style={{backgroundImage: ` url(${pathSuite + compilations[0].imageUrl})`}}
                className="collections__card"
                onClick={() => getDetailedInfo(idCompilations)}
            >
                <div className="collections__card-container">
                    <div className="collections__card-name">
                        {compilations[0].name}
                    </div>
                    <div className="collections__card-description">
                        {compilations[0].description}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CompilationsGroupCard;
